<template>
  <div>
    <v-dialog v-model="showAbortMotivationDialog" width="500">
      <v-card>
        <v-card-title>
          <div class="headline">Passage en abandon</div>
        </v-card-title>
        <v-card-text>
          <p>Quelle est la raison de l'abandon ?</p>
          <v-radio-group v-model="abortMotivation">
            <v-radio
              v-for="m in abortMotivations"
              :key="m"
              class="mb-1"
              :value="m"
              :label="m"
            />
          </v-radio-group>
        </v-card-text>
        <v-card-actions class="d-flex d-flex-initial justify-end">
          <v-btn flat>Annuler</v-btn>
          <v-btn
            color="primary"
            :disabled="abortMotivation === null"
            @click="setAbort"
          >
            Valider
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-layout row wrap class="mt-2">
      <v-flex xs12 lg6>
        <FormLine
          :item="{
            items: states,
            value: () => state,
            as: 'select',
            name: 'state',
            label: 'État',
            update: onStateUpdate
          }"
          :edit-mode="editMode"
        />
        <FormLine
          v-if="state === 'stopped'"
          :item="{ name: 'abortMotivation', label: 'Cause de l\'abandon' }"
          v-model="project"
          :edit-mode="false"
        />
      </v-flex>
      <v-flex xs12 lg6>
        <FormLine
          :item="{
            items: serviceWish,
            as: 'select',
            name: 'serviceWish',
            label: 'Type de service'
          }"
          v-model="project"
          key="serviceWish"
          :edit-mode="editMode"
        />
      </v-flex>
    </v-layout>
    <v-layout row wrap>
      <v-flex lg6 xs12>
        <h3 class="ml-3">Informations du projet</h3>
        <template v-for="item in projectinfos">
          <FormLine
            :item="item"
            v-model="project"
            :key="item.name"
            :edit-mode="editMode"
          ></FormLine>
          <v-divider :key="`${item.name}-divider`" />
        </template>
        <h3 class="mt-4">Dossier locatif</h3>
        <v-list v-if="project">
          <template v-for="item in dossier">
            <FormLine
              :item="item"
              v-model="project"
              :key="item.name"
              :edit-mode="editMode"
            ></FormLine>
            <v-divider :key="`${item.name}-divider`" />
          </template>
        </v-list>
        <v-menu offset-y>
          <template v-slot:activator="{ on }">
            <div style="position: relative">
              <v-btn
                color="primary"
                class="mt-3"
                dark
                v-on="on"
                absolute
                right
                small
                top
                v-if="editMode"
              >
                <v-icon>add</v-icon>
              </v-btn>
              <h3 class="ml-3 mt-4">Services</h3>
            </div>
          </template>
          <v-list>
            <v-list-tile
              v-for="service in services"
              :key="service"
              @click="addService(service)"
            >
              <v-list-tile-title>{{ service }}</v-list-tile-title>
            </v-list-tile>
          </v-list>
        </v-menu>
        <v-list
          v-if="
            (project && project.services && project.services.length > 0) ||
              editMode
          "
        >
          <template v-for="(service, index) in project.services">
            <v-list-tile :key="service.name">
              <v-list-tile-content>{{ service.name }}</v-list-tile-content>
              <v-list-tile-action v-if="!editMode">
                <v-icon :color="service.done ? 'primary' : 'secondary'">{{
                  service.done ? "check_box" : "indeterminate_check_box"
                }}</v-icon>
              </v-list-tile-action>
              <v-list-tile-action v-if="editMode">
                <v-icon color="red" @click="removeService(index)"
                  >remove</v-icon
                >
              </v-list-tile-action>
              <v-list-tile-action v-if="editMode">
                <v-icon
                  color="primary"
                  @click="toggleServiceStatus(index)"
                  v-if="!service.done"
                  >check</v-icon
                >
                <v-icon
                  color="secondary"
                  @click="toggleServiceStatus(index)"
                  v-else
                  >history</v-icon
                >
              </v-list-tile-action>
            </v-list-tile>
          </template>
        </v-list>
        <div v-else class="empty-message">Aucun service proposé</div>
      </v-flex>
      <v-flex xs12 lg6>
        <h3
          class="mb-3"
          :class="{ 'missing-section': !check('descEstateAdmin') }"
        >
          Bien idéal
        </h3>
        <v-list-tile class="no-height">
          <v-list-tile-content class="no-height">
            <v-list-tile-title>Il a écrit :</v-list-tile-title>
            <div class="no-clamp fsz">
              {{ project.descEstate || "Non défini" }}
            </div>
          </v-list-tile-content>
        </v-list-tile>
        <v-list-tile class="no-height">
          <v-list-tile-content class="no-height">
            <v-list-tile-title>HiL a écrit :</v-list-tile-title>
            <v-textarea
              v-model="project.descEstateAdmin"
              style="width: 100%"
              :readonly="!editMode"
              :disabled="!editMode"
            ></v-textarea>
          </v-list-tile-content>
        </v-list-tile>
        <div class="general-hints">
          <h4>Fil conducteur</h4>
          <ul>
            <li>Meublé ? Cuisine équipée / emmenagée ? Ancien ou neuf ?</li>
            <li>Nombre de chambres</li>
            <li>Extérieur ? Garage ?</li>
            <li>Étage max sans ascenseur</li>
            <li>Rez de chaussée ?</li>
          </ul>
        </div>
        <h3
          class="mb-3"
          :class="{ 'missing-section': !check('futurNeighborhoodAdmin') }"
        >
          Attentes vis à vis du quartier
        </h3>
        <v-list-tile class="no-height">
          <v-list-tile-content class="no-height">
            <v-list-tile-title>Il a écrit :</v-list-tile-title>
            <div class="no-clamp fsz">
              {{ project.futurNeighborhood || "Non défini" }}
            </div>
          </v-list-tile-content>
        </v-list-tile>
        <v-list-tile class="no-height">
          <v-list-tile-content class="no-height">
            <v-list-tile-title>HiL a écrit :</v-list-tile-title>
            <v-textarea
              v-model="project.futurNeighborhoodAdmin"
              style="width: 100%"
              :readonly="!editMode"
              :disabled="!editMode"
            ></v-textarea>
          </v-list-tile-content>
        </v-list-tile>
        <div class="general-hints">
          <h4>Fil conducteur</h4>
          <ul>
            <li>
              Dans quel quartiez habitez vous ? Avantages et inconvénients
            </li>
            <li>
              Connaissez vous la ville ? Connaissez vous votre quartier idéal ?
            </li>
            <li>Distance du travail souhaité</li>
          </ul>
        </div>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import { SERVICE_WISH } from "../../../../webapp-commons/data";
import FormLine from "../commons/FormLine.vue";
import { SERVICES } from "../../data/DefaultSettings.js";
import { ABORT_MOTIVATIONS, ALL_COLUMNS } from "../../data/DefaultSettings";
import { checkFormLine } from "../../utils";
import { addDistancesToLease } from "../../services/maps";
import { mapGetters } from "vuex";

export var IS_REFRESHING_DIRECTIONS = false;

export default {
  props: ["project", "editMode", "fieldsGetter", "validators"],
  components: {
    FormLine
  },
  inject: ["$validator"],
  data() {
    return {
      abortMotivation: null,
      showAbortMotivationDialog: false,
      distance: null,
      time: null,
      states: [
        { text: "En cours", value: "working" },
        { text: "Abandonné", value: "stopped" }
      ],
      ...this.fieldsGetter.call(this, this.validators)
    };
  },
  timers: {
    checkAddress: { time: 5000, autostart: true, repeat: true }
  },
  methods: {
    addService(service) {
      if (!this.project.services) {
        this.project.services = [];
      }
      this.project.services.push({
        name: service,
        done: null
      });
      this.$forceUpdate();
    },
    removeService(idx) {
      this.project.services.splice(idx, 1);
      this.$forceUpdate();
    },
    toggleServiceStatus(idx) {
      if (this.project.services[idx].done != null) {
        this.project.services[idx].done = null;
      } else {
        this.project.services[idx].done = new Date();
      }
      this.$forceUpdate();
    },
    onStateUpdate(state, confirm = false) {
      if (state === "working") {
        this.project.stopped = false;
      } else if (state === "stopped" && !confirm) {
        this.showAbortMotivationDialog = true;
      } else if (state === "stopped" && confirm) {
        this.project.stopped = true;
        this.showAbortMotivationDialog = false;
      }
      this.$forceUpdate();
    },
    setAbort() {
      this.project.abortMotivation = this.abortMotivation;
      this.abortMotivation = null;
      this.onStateUpdate("stopped", true);
    },

    async refreshDirections() {
      IS_REFRESHING_DIRECTIONS = true;
      const d = await addDistancesToLease(this.project);
      this.project.lastContractualAddress1 = d.lastContractualAddress1;
      this.project.lastContractualAddress2 = d.lastContractualAddress2;
      this.project.contractualDistance = d.contractualDistance;
      this.project.contractualTime = d.contractualTime;
      this.distance = d.contractualDistance;
      this.time = d.contractualTime;
      IS_REFRESHING_DIRECTIONS = false;
      this.$forceUpdate();
    },

    async checkAddress() {
      if (
        !IS_REFRESHING_DIRECTIONS &&
        this.project.addressWorkObject != null &&
        this.project.fromAddressObject != null &&
        (this.project.actualCity !== this.project.lastContractualAddress1 ||
          this.project.addressWork !== this.project.lastContractualAddress2)
      ) {
        this.refreshDirections();
      }
    },

    check(att) {
      return checkFormLine(
        this.validators[att],
        this.project[att],
        this.project
      );
    }
  },
  computed: {
    ...mapGetters("user", ["isSuperAdmin"]),

    serviceWish() {
      return SERVICE_WISH;
    },
    abortMotivations() {
      return ABORT_MOTIVATIONS;
    },
    state() {
      if (this.project?.progress?.stopped) {
        return "stopped";
      } else {
        return "working";
      }
    },
    progresses() {
      const columns = ALL_COLUMNS.filter(
        ({ isAgregate }) => !isAgregate
      ).map((c, i) => ({ ...c, text: `[${i < 10 ? `0${i}` : i}] ${c.text}` }));
      if (this.isSuperAdmin) {
        return columns;
      } else {
        return columns.filter(({ superAdminOnly }) => !superAdminOnly);
      }
    },
    services() {
      return SERVICES;
    }
  }
};
</script>

<style scoped>
.no-clamp {
  -webkit-line-clamp: 1000 !important;
}

.fsz {
  font-size: 12px !important;
}

.general-hints {
  color: #555;
  margin-left: 30px;
  margin-bottom: 24px;
}

.missing-section {
  background: darkorange;
}
</style>
